import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2BroccoliIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 21.015 21",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 21.015),
    children: [/*#__PURE__*/jsx("path", {
      d: "m13.765 12.08a11.652 11.652 0 0 0 -4.844-4.847"
    }), /*#__PURE__*/jsx("path", {
      d: "m6.835 7.233c-.514 3.317-2.632 5.908-5.808 8.32a1.342 1.342 0 0 0 -.132 2.016l2.533 2.537a1.342 1.342 0 0 0 2.016-.133c2.412-3.174 5-5.293 8.319-5.807"
    }), /*#__PURE__*/jsx("path", {
      d: "m10.136 15.493a4.028 4.028 0 0 0 7.937-.586 4.022 4.022 0 0 0 -.022-7.391 4.008 4.008 0 0 0 -4.565-4.57 4.022 4.022 0 0 0 -7.392-.021 4.032 4.032 0 0 0 -.588 7.935"
    }), /*#__PURE__*/jsx("path", {
      d: "m9.883 5.75a2.021 2.021 0 0 1 -3.933.36"
    }), /*#__PURE__*/jsx("path", {
      d: "m8.829 10.265 1.872-1.872"
    }), /*#__PURE__*/jsx("path", {
      d: "m10.735 12.169 1.87-1.871"
    }), /*#__PURE__*/jsx("path", {
      d: "m15.25 11.117a2.021 2.021 0 0 0 -.361 3.933"
    })]
  });
};

export { PM2BroccoliIcon };
//# sourceMappingURL=brocolli.js.map
